





























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
// @ts-ignore
import KUTE from 'kute.js';

import { TransitionWobbleProps } from '@/components/wobble/model';

@Component
export default class TransitionWobble extends Vue {
  @Prop({ required: true }) readonly twProps!: TransitionWobbleProps;
  @Prop({ required: true }) readonly duration!: number;
  @Prop({ required: true }) readonly visible!: boolean;

  private svgTween: any;
  private boxTween: any;
  private startColorTween: any;
  private stopColorTween: any;
  private gradientCoordinateTween: any;

  created() {
  }

  mounted() {
  }

  @Watch('visible', {
    immediate: true
  })
  async watchVisible() {
    if (!this.visible) {
      return;
    }

    await Vue.nextTick();

    // re-init the svgTween and boxTween and start them
    this.svgTween = KUTE.to(
      '#transition-wobble-path',
      {
        path: this.twProps?.targetPath
      },
      {
        morphPrecision: 0.000000001,
        duration: this.duration,
        easing: 'easingSinusoidalInOut',
        onComplete: () => {
          this.$emit('completed');
        }
      }
    );
    this.boxTween = KUTE.fromTo(
      '#transition-wobble-box',
      {
        top: this.twProps.sourceOrigin?.y,
        left: this.twProps.sourceOrigin?.x,
        width: this.twProps.sourceSize?.x,
        height: this.twProps.sourceSize?.y,
      },
      {
        top: this.twProps.targetOrigin?.y,
        left: this.twProps.targetOrigin?.x,
        width: this.twProps.targetSize?.x,
        height: this.twProps.targetSize?.y,
      },
      {
        duration: this.duration,
        easing: 'easingSinusoidalInOut',
      }
    );
    this.gradientCoordinateTween = KUTE.to(
      '#transition-wobble-gradient',
      {
        attr: {
          'x1': this.twProps.targetGradient?.x1,
          'y1': this.twProps.targetGradient?.y1,
          'x2': this.twProps.targetGradient?.x2,
          'y2': this.twProps.targetGradient?.y2,
        }
      },
      {
        duration: this.duration,
        easing: 'easingSinusoidalInOut',
      }
    );
    this.startColorTween = KUTE.to(
      '#startColor',
      {
        attr: {
          'stop-color': this.twProps.targetGradient?.startColor,
          'offset': this.twProps.targetGradient?.startOffset,
        }
      },
      {
        duration: this.duration,
        easing: 'easingSinusoidalInOut',
      }
    );
    this.stopColorTween = KUTE.to(
      '#stopColor',
      {
        attr: {
          'stop-color': this.twProps.targetGradient?.stopColor,
          'offset': this.twProps.targetGradient?.stopOffset,
        }
      },
      {
        duration: this.duration,
        easing: 'easingSinusoidalInOut',
      }
    );
    try {
      this.svgTween.start();
      this.boxTween.start();
      this.startColorTween.start();
      this.stopColorTween.start();
      this.gradientCoordinateTween.start();
    } catch (e: any) {
      console.log(e);
      this.$emit('error');
    }
  }
}
